// Operator-facing surface — EN only. Maps known Supabase / PostgREST error
// codes to user-friendly strings; everything else falls back to a generic
// message. Never render raw error.message in admin — it leaks Postgres /
// PostgREST internals. The raw error is always logged for Sentry.

const MESSAGES = {
  over_email_send_rate_limit:  'Too many requests. Please wait a minute and try again.',
  over_request_rate_limit:     'Too many requests. Please wait a moment and try again.',
  invalid_credentials:         'Incorrect email or password.',
  weak_password:               'Please choose a stronger password.',
  same_password:               'Please choose a different password.',
  user_already_exists:         'An account already exists for this email.',
  email_address_not_authorized:'We can’t send to that email address.',
  default:                     'Something went wrong. Please try again.',
};

export function localiseError(error) {
  if (!error) return '';
  console.error('[localiseError]', error);
  const code = error.code || error.name || '';
  return MESSAGES[code] || MESSAGES.default;
}
